import { useEffect, useState } from "react";
import { columnsheadId } from "../../universal/columnshead";
import MenuSpecSpecialUploadFileEdit from "./MenuSpecSpecialUploadFileEdit";
import systemExpand from "../../../config/systemExpand";
import UploadFileListUniversal, { UFLUExtendPropsType } from "../../system/UploadFileListUniversalNewEx";

//组件 MenuSpecSpecialUploadFile
export default function MenuSpecSpecialUploadFile(props: any) {

    //extendProps 
    const [extendProps, setExtendProps] = useState<UFLUExtendPropsType>();

    //表头
    const columnsHead = [
        // {
        //     title: '菜式',
        //     dataIndex: 'foodName',
        //     render: (text: any, record: any) => {
        //         return (
        //             <div>{record.menuSpecSpecial.menu.foodName}</div>
        //         )
        //     }
        // },
        {
            title: '特殊规格',
            dataIndex: 'menuSpecSpecialName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.menuSpecSpecial.menuSpecSpecialName}</div>
                )
            }
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];

    const filesColumns = columnsheadId
        .concat(columnsHead as []);

    useEffect(() => {
        systemExpand.getConfig({
            id: 'config',
            nodeId: 'files'
        }).then(res => {
            const { files } = res as any;
            const { menuSpecSpecialFilesGroupId } = files;
            setExtendProps({
                ...props,
                titleName: '菜式特殊规格图片',
                apiId: 'menuSpecSpecial',
                filesGroupId: menuSpecSpecialFilesGroupId,
                fileType: "files",
                //+ File
                //上传 + UploadFile
                //删除 + DeleteFile
                filesColumns,
                showImage: true,
                showDownload: true,
                showStates: true,
                showDefault: true,
                showFileUpload: sessionStorage.getItem('isAdmin') === 'true' ? true : false,
                showFileSelection: true,
                showOperation: true,
                extendIdName: "menuSpecSpecialId",
                EditComponent: MenuSpecSpecialUploadFileEdit,
                disableCheckBox: sessionStorage.getItem('isAdmin') === 'true' ? false : true
            })
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (extendProps) {
        return (
            <UploadFileListUniversal props={extendProps} />
        )
    }
}